import React, { PureComponent } from 'react';

class SelectBankCachier extends PureComponent {

    render() {

        const { Validaciones, ValidarPantalla, Cuenta, GET_CATEGORIA_CAJERO, seleccionarCombo } = this.props;

        const optionCategorias = GET_CATEGORIA_CAJERO.map((categoria, index) => {
            return (
                <option key={"categoria-option-" + index} value={categoria.Id} data-codigo={categoria.Codigo}>
                    {categoria.Descripcion}
                </option>
            );
        });

        let mensajeError = null;
        if (ValidarPantalla == true) {
            if (Validaciones.CategoriaSeleccionada == false) {
                mensajeError = <label className="error">Debe seleccionar una categoria</label>;
            }
        }

        return (
        <div className="bottom-separator-xs">

            <div className="row">
                <div className="col-xs-12">
                    <label className="label-primary">Categoría ATM</label>
                </div>
            </div>

            <div className="row">

                <div className="col-xs-6">
                    <select value={Cuenta.CategoriaCajeroVisaId}
                        className="form-control default-select"
                        onChange={(event) => {
                            let index = event.target.selectedIndex;
                            let optionActual = event.target.options[index];
                            seleccionarCombo(event.target.value, "CATEGORIA-ATM", optionActual.dataset.codigo)
                        }}>
                        <option value="0">Seleccione...</option>
                        {optionCategorias}
                    </select>
                </div>

                <div className="col-xs-12">
                    {mensajeError}
                </div>

            </div>

        </div>
        );

    }
    
}

export default SelectBankCachier;